
import { defineComponent, ref, reactive, toRefs, onMounted, computed, watch, nextTick, watchEffect } from 'vue'

import { useRoute } from 'vue-router'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import api from '@/api/allApi'
export default defineComponent({
  props: {
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { Table, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      data: [],
      columns: [],
      total: 0,
      pagination: {
        showSizeChanger: true,
        showTotal: (total: any) => `共${total}条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTitle: false
      },
      spinning: true
    })
    pageData.columns = [
      {
        title: '日期',
        dataIndex: 'formatDate',
        key: 'formatDate',
        width: '100px'
      },
      {
        title: '媒体',
        dataIndex: 'Media',
        key: 'Media',
        width: '150px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '标题',
        dataIndex: 'Title',
        key: 'zxTitle',
        slots: { customRender: 'link', type: 'link' },
        ellipsis: true
      }
    ]
    onMounted(() => {
      // getResearchDetail();
    })
    const route = useRoute()
    watch(
      () => props.pageSourceData,
      () => {
        pageData.data = handlerData(((props.pageSourceData || {}).IndustryAnnouncementData || {}).NewsOrNoticeDataData)
        pageData.total = (pageData.data || []).length
      }
    )
    function handlerData(arr: any) {
      nextTick(() => {
        pageData.spinning = false
      })
      if ((arr || []).length < 1) {
        return []
      }
      arr.forEach((item: any, i: number) => {
        item.index = 'GszxDetail' + i
        item.formatDate = item.PubTime ? window.moment(item.PubTime * 1000).format('YYYY-MM-DD') : '—'
      })
      return arr
    }
    return {
      ...toRefs(pageData)
    }
  }
})
